import React from "react";
import styles from "./HomeCard.module.css";

interface HomeCardProps {
    header?: React.ReactNode;
    children: React.ReactNode; // Content of the card
}

const HomeCard: React.FC<HomeCardProps> = ({
    header,
    children,
}) => {
    return (
        <div className={styles.section}>
            {header}
            <div className={`${styles.content} ${header ? styles.inset : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default HomeCard;
